import { useCallback, useState } from "react";

export type PrimaryToolbarMenu = "shape" | "draw" | null;

/** Manages the Shapes and Draw primary toolbar flyouts. */
export function useToolbarPopoverCoordinator() {
  const [open, setOpen] = useState<PrimaryToolbarMenu>(null);

  const closeAll = useCallback(() => {
    setOpen(null);
  }, []);

  const toggleMenu = useCallback((menu: PrimaryToolbarMenu) => {
    setOpen((current) => (current === menu ? null : menu));
  }, []);

  return {
    open,
    setOpen,
    closeAll,
    toggleMenu,
  };
}
